import React from 'react'

const Linkedin = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_101_592)">
                <path d="M24.3715 4H5.62422C4.72617 4 4 4.70898 4 5.58555V24.4102C4 25.2867 4.72617 26 5.62422 26H24.3715C25.2695 26 26 25.2867 26 24.4145V5.58555C26 4.70898 25.2695 4 24.3715 4ZM10.527 22.7473H7.26133V12.2457H10.527V22.7473ZM8.89414 10.8148C7.8457 10.8148 6.99922 9.96836 6.99922 8.92422C6.99922 7.88008 7.8457 7.03359 8.89414 7.03359C9.93828 7.03359 10.7848 7.88008 10.7848 8.92422C10.7848 9.96406 9.93828 10.8148 8.89414 10.8148ZM22.7473 22.7473H19.4859V17.6426C19.4859 16.4266 19.4645 14.8582 17.7887 14.8582C16.0914 14.8582 15.8336 16.1859 15.8336 17.5566V22.7473H12.5766V12.2457H15.7047V13.6809H15.7477C16.1816 12.8559 17.2473 11.9836 18.8328 11.9836C22.1371 11.9836 22.7473 14.1578 22.7473 16.9852V22.7473Z" fill="currentColor"></path>
            </g>
            <defs>
                <clipPath id="clip0_101_592">
                    <rect fill="currentColor" height="22" transform="translate(4 4)" width="22"></rect>
                </clipPath>
            </defs>
        </svg>
    )
}

export default Linkedin
